import { LabCaseRunPrintOptionsModel } from "@app/api2/api";
import React from "react";

// const defaultPrintOptions = {
//   aicRuns: true,
//   caseRunDetails: true,
//   caseRunNotes: true,
//   hdDeconvAllJoint: true,
//   hdDeconvAllMarginalAlleles: true,
//   hdDeconvAllMarginalGeno: true,
//   hdDeconvTopMarginal: true,
//   hdFittedModel: true,
//   hpDeconvAllMarginalAlleles: true,
//   hdMcmcParameters: true,
//   hdModelValidation: true,
//   hdParameterEstimates: true,
//   hpDeconvAllJoint: true,
//   hpDeconvAllMarginalGeno: true,
//   hpDeconvTopMarginal: true,
//   hpFittedModel: true,
//   hpMcmcParameters: true,
//   hpModelValidation: true,
//   hpParameterEstimates: true,
//   resultsBayesianNumericalParameters: true,
//   resultsEpgOverlay: true,
//   resultsMcmcParameters: true,
//   resultsMlSystems: true,
//   resultsSensitivityGraph: true
// } as LabCaseRunPrintOptionsModel

export const PrintContext = React.createContext<LabCaseRunPrintOptionsModel>(undefined);

// type Props = {
//   children: React.ReactNode
// };

// export const PrintContextProvider = ({
//     children
//   }: Props) => {
//     const [theme, setTheme] = React.useState(
//       {defaultTheme}
//     );
  
//     React.useEffect(() => {
//       // We'd get the theme from a web API / local storage in a real app
//       // We've hardcoded the theme in our example
//       const currentTheme = "lightblue";
//       setTheme(currentTheme);
//     }, []);
  
//     return (
//       <ThemeContext.Provider value={theme}>
//         {children}
//       </ThemeContext.Provider>
//     );
//   };